import { render, staticRenderFns } from "./InfUnitOfMeasurement.vue?vue&type=template&id=ccf51c5e&"
import script from "./InfUnitOfMeasurement.vue?vue&type=script&lang=js&"
export * from "./InfUnitOfMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports